import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const buildSelectableOptionsWithImageAndDescription = <
  U extends string | number | symbol,
  T extends Record<
    U,
    { name: string; image?: string; description: string } | undefined
  >,
>(
  entityEnum: T
): Record<U, React.ReactNode> =>
  (
    Object.entries(entityEnum) as [
      U,
      { name: string; image?: string; description: string } | undefined,
    ][]
  )
    .filter(
      (v): v is [U, { name: string; image?: string; description: string }] =>
        !!v[1]
    )
    .reduce(
      (acc, [key, { name, image, description }]) => {
        acc[key] = (
          <Box p={3} maxWidth={320}>
            {image && <img src={image} alt={name} width={280} height={150} />}
            <Typography variant="h5">{name}</Typography>
            <Typography variant="subtitle1">{description}</Typography>
          </Box>
        );
        return acc;
      },
      {} as Record<U, React.ReactNode>
    );
